/* khs-sticky-atb.js --------------------------------------------------
   Mobile-only pinned add-to-bag bar that appears only once the in-page
   add-to-bag button has scrolled out of view.

   Flicker-proofing: we use IntersectionObserver (NOT a scroll listener),
   so the state changes at most twice — when the inline button leaves the
   viewport and when it comes back. A short CSS transition smooths it.

   Behaviour:
     - inline button visible  -> sticky bar hidden
     - inline button off-screen -> sticky bar shown
   The sticky bar IS the real .product-form__buttons (fixed via CSS), so
   it always submits the real form. We watch a separate "sentinel": the
   inline add-to-bag button if present, otherwise the product form.
------------------------------------------------------------------- */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 749px)');
  var observer = null;
  var sentinel = null;

  function pin(on) {
    document.body.classList.toggle('khs-atb-pinned', on);
    if (!on) document.body.classList.remove('khs-atb-visible');
  }

  function showSticky(show) {
    document.body.classList.toggle('khs-atb-visible', show);
  }

  function findSentinel() {
    // prefer the inline in-page button; fall back to the form container
    return document.querySelector('.khs-inline-atb') ||
           document.querySelector('.product-form__buttons');
  }

  function teardown() {
    if (observer) { observer.disconnect(); observer = null; }
    sentinel = null;
  }

  function setup() {
    teardown();

    var form = document.querySelector('.product-form__buttons');
    var hasButton = form && form.querySelector('.product-form__submit');

    if (!hasButton || !MQ.matches) {
      pin(false);
      return;
    }

    // pin the bar (CSS keeps it hidden until khs-atb-visible is added)
    pin(true);

    sentinel = findSentinel();
    if (!sentinel) { showSticky(true); return; }

    // If the sentinel IS the form itself (no inline button), showing the
    // sticky only once the form scrolls away would hide it permanently
    // (they're the same element). In that case just show it always.
    if (sentinel === form) { showSticky(true); return; }

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // inline button in view -> hide sticky; out of view -> show sticky
        showSticky(!entry.isIntersecting);
      });
    }, {
      root: null,
      // small negative bottom margin so the sticky appears a touch before
      // the inline button is fully gone (feels responsive, avoids overlap)
      rootMargin: '0px 0px -40px 0px',
      threshold: 0
    });

    observer.observe(sentinel);
  }

  function boot() {
    setup();
    MQ.addEventListener('change', setup);

    // the theme re-renders the product form on variant change; re-attach
    // the observer if our sentinel gets replaced in the DOM.
    var host = document.querySelector('.product-form') || document.body;
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () {
        var current = findSentinel();
        if (current !== sentinel) setup();
      });
      mo.observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
